import React from 'react';
import { cn } from '../../lib/utils';

export const Title = React.forwardRef<HTMLHeadingElement, React.HTMLAttributes<HTMLHeadingElement>>(({ children, className, ...props }, ref) => {
    return (
        <h1 className={cn('text-primary font-bold text-2xl', className)} ref={ref} {...props}>
            {children}
        </h1>
    );
});
